/*
 * Freezer-Produktseite (Template product.freezer), Kern: Daten, Auswahl (Konfigurator), Hero, Überblick, Anlage.
 * Alle Werte kommen aus #frz-data (Produkt, Varianten, Metafelder, Lagersystem-Datenbank), alle Texte aus #frz-i18n
 * (Sprachdateien, Schlüssel "freezer.*"). Keine festen Zahlen, keine Handles. Weitere Module: freezer-sections.js, freezer-planer.js.
 */
(function () {
  'use strict';
  if (window.CryoFreezer && window.CryoFreezer.ready) return;

  var CF = window.CryoFreezer = { ready: true, renderers: {}, S: {}, D: null, TX: {} };

  /* ---------- Hilfen ---------- */
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); };
  var LANG = (document.documentElement.lang || 'en').split('-')[0];
  var nf = (function () { try { return new Intl.NumberFormat(LANG); } catch (e) { return new Intl.NumberFormat('en'); } })();
  var nf1 = (function () { try { return new Intl.NumberFormat(LANG, { minimumFractionDigits: 1, maximumFractionDigits: 1 }); } catch (e) { return new Intl.NumberFormat('en', { minimumFractionDigits: 1, maximumFractionDigits: 1 }); } })();
  var fmt = function (n) { return nf.format(n); };
  var fmt1 = function (n) { return nf1.format(n); };
  var isNum = function (x) { return typeof x === 'number' && isFinite(x); };
  function T(key, vars) {
    var s = CF.TX[key];
    if (s == null) return key;
    return vars ? String(s).replace(/\{(\w+)\}/g, function (m, n) { return vars[n] != null ? vars[n] : m; }) : String(s);
  }
  function has(key) { return CF.TX[key] != null && CF.TX[key] !== ''; }
  var money = function (c) { return typeof window.cryonosMoney === 'function' ? window.cryonosMoney(c) : (c / 100).toFixed(2); };
  function tbd() { return '<span class="frz-tbd">' + esc(T('common.tbd')) + '</span>'; }
  CF.$ = $; CF.$$ = $$; CF.esc = esc; CF.fmt = fmt; CF.fmt1 = fmt1; CF.T = T; CF.has = has; CF.money = money; CF.isNum = isNum; CF.tbd = tbd; CF.LANG = LANG;

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { console.error('freezer: JSON ' + id, e); return null; }
  }

  /* ---------- Zeichenfarben (wie Prototyp) ---------- */
  var K = { ln: '#cfd5db', lo: 'rgba(207,213,219,.42)', acc: '#e4c552', ln2: '#7fb7e6', tx: '#cfd5db', mu: '#8e979f', fill: '#1b2127', s1: '#3a434b', s2: '#aeb6bd' };
  CF.K = K;
  var uid = 0;
  function defs(id) { return '<defs><marker id="' + id + 'a" viewBox="0 0 8 8" refX="7" refY="4" markerWidth="7" markerHeight="7" orient="auto-start-reverse"><path d="M0 0 L8 4 L0 8 Z" fill="' + K.acc + '"/></marker><marker id="' + id + 'd" viewBox="0 0 6 6" refX="3" refY="3" markerWidth="5" markerHeight="5"><circle cx="3" cy="3" r="2.2" fill="' + K.acc + '"/></marker><linearGradient id="' + id + 's" x1="0" x2="1"><stop offset="0" stop-color="' + K.s1 + '"/><stop offset=".45" stop-color="' + K.s2 + '"/><stop offset="1" stop-color="' + K.s1 + '"/></linearGradient><linearGradient id="' + id + 'n" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="' + K.ln2 + '" stop-opacity=".18"/><stop offset="1" stop-color="' + K.ln2 + '" stop-opacity=".55"/></linearGradient><pattern id="' + id + 'h" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><line x1="0" y1="0" x2="0" y2="6" stroke="' + K.lo + '" stroke-width="1"/></pattern></defs>'; }
  function dim(id, x1, y1, x2, y2, l, o) { var v = x1 === x2, lx = v ? x1 + (o || 12) : (x1 + x2) / 2, ly = v ? (y1 + y2) / 2 : y1 - (o || 8); return '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" stroke="' + K.acc + '" stroke-width="1" marker-start="url(#' + id + 'a)" marker-end="url(#' + id + 'a)"/><text x="' + lx + '" y="' + ly + '" fill="' + K.acc + '" font-size="12" font-weight="700" font-family="Archivo,Arial" letter-spacing=".04em" text-anchor="middle"' + (v ? ' transform="rotate(-90 ' + lx + ' ' + ly + ')"' : '') + '>' + esc(l) + '</text>'; }
  function lead(id, x, y, tx, ty, l, a) { var e = a === 'end'; return '<polyline points="' + x + ',' + y + ' ' + tx + ',' + ty + ' ' + (tx + (e ? -14 : 14)) + ',' + ty + '" fill="none" stroke="' + K.lo + '" marker-start="url(#' + id + 'd)"/><text x="' + (tx + (e ? -18 : 18)) + '" y="' + (ty + 4) + '" fill="' + K.tx + '" font-size="11.5" text-anchor="' + (e ? 'end' : 'start') + '" font-family="Inter,Arial">' + esc(l) + '</text>'; }
  var lab = function (x, y, t, c) { return '<text x="' + x + '" y="' + y + '" fill="' + (c || K.acc) + '" font-size="11" font-family="Archivo,Arial" font-weight="800" letter-spacing=".16em">' + esc(t) + '</text>'; };
  CF.svg = { defs: defs, dim: dim, lead: lead, lab: lab };

  /* ---------- Daten aufbereiten ---------- */
  function boot() {
    var D = readJson('frz-data');
    if (!D) return false;
    CF.D = D; CF.TX = readJson('frz-i18n') || {};
    var cfg = D.cfg || {};
    cfg.optionen = cfg.optionen || {}; cfg.modelle = cfg.modelle || {};
    D.cfg = cfg;
    var own = D.product, twin = D.twin;
    var all = [];
    [own, twin].forEach(function (p) {
      if (!p) return;
      p.variants.forEach(function (v) { v.pid = p.id; v.mdr = !!p.mdr; v.handle = p.handle; v.purl = p.url; all.push(v); });
    });
    all.forEach(function (v) {
      var r = {};
      (v.oi || []).forEach(function (ix, i) {
        var def = cfg.optionen[String(i + 1)], w = def && def.werte && def.werte[String(ix)];
        if (w) for (var k in w) r[k] = w[k];
      });
      v.r = r;
    });
    CF.variants = all;
    CF.roles = ['kar', 'phase', 'medium', 'sys', 'fill'].filter(function (k) { return all.some(function (v) { return v.r[k] != null; }); });
    CF.products = {}; if (own) CF.products[own.id] = own; if (twin) CF.products[twin.id] = twin;
    CF.hasTwin = !!twin && own.mdr !== twin.mdr;
    CF.mdrAvailable = !!(own.mdr || (twin && twin.mdr));
    return true;
  }

  /* Variantenwahl */
  var S = CF.S;
  function sameSel(v, sel, roles) { return (roles || CF.roles).every(function (r) { return v.r[r] === sel[r]; }); }
  function pickVariant(sel) {
    var list = CF.variants.filter(function (v) { return v.mdr === sel.mdr; });
    for (var i = 0; i < list.length; i++) if (sameSel(list[i], sel)) return list[i];
    return null;
  }
  function selFromVariant(v) { var s = { mdr: v.mdr }; CF.roles.forEach(function (r) { s[r] = v.r[r]; }); return s; }
  /* Rolle ändern: passt keine Variante, nimmt die ähnlichste (frühere Schritte haben Vorrang). */
  function choose(role, value) {
    var sel = Object.assign({}, S.sel); sel[role] = value;
    var v = pickVariant(sel);
    if (!v) {
      var best = null, bestScore = -1;
      CF.variants.forEach(function (c) {
        if (c.mdr !== sel.mdr || c.r[role] !== value) return;
        var score = 0;
        CF.roles.forEach(function (r, i) { if (r !== role && c.r[r] === sel[r]) score += Math.pow(2, CF.roles.length - i); });
        if (score > bestScore) { best = c; bestScore = score; }
      });
      v = best;
    }
    if (v) { S.sel = selFromVariant(v); S.pos = 0; S.slide = 0; changed(); }
  }
  function isDisabled(role, value) {
    var idx = CF.roles.indexOf(role), earlier = CF.roles.slice(0, idx);
    return !CF.variants.some(function (v) { return v.mdr === S.sel.mdr && v.r[role] === value && earlier.every(function (r) { return v.r[r] === S.sel[r]; }); });
  }
  function setMdr(flag) {
    var sel = Object.assign({}, S.sel, { mdr: !!flag });
    var v = pickVariant(sel);
    if (v) { S.sel = selFromVariant(v); changed(); }
  }
  CF.choose = choose; CF.setMdr = setMdr; CF.isDisabled = isDisabled;

  /* Abgeleitete Größen der aktuellen Auswahl */
  function modelOf(v) { var m = CF.D.cfg.modelle; return m[v.r.kar != null ? v.r.kar : '*'] || m['*'] || m[Object.keys(m)[0]] || {}; }
  function systemOf(v) {
    var list = CF.D.systems || [];
    for (var i = 0; i < list.length; i++) if (list[i].varianten.indexOf(v.id) > -1) return list[i];
    return null;
  }
  /* Lagersystem gehört zum Modell: gleiche Ebenenzahl und Modellname (Name des Systems beginnt mit dem Modellnamen, z. B. SYS 480 mit Rahmen/ohne Rahmen). */
  CF.sameModel = function (s, M) { return String(s.ebenen) === String(M.ebenen) && String(s.freezer_name || '').toUpperCase().indexOf(String(M.freezer_name || '').toUpperCase()) === 0; };
  function systemsOfModel(M, phase) {
    return (CF.D.systems || []).filter(function (s) { return CF.sameModel(s, M) && (phase == null || s.phase === phase); });
  }
  function sums(s) {
    if (!s) return null;
    var P = window.CryoPlanner, o = { boxes: s.summe.boxen, vials: s.summe.vials, goblets: s.summe.goblets, s25: s.summe.straws_025, s05: s.summe.straws_05 };
    if (!isNum(o.vials)) o.vials = s.art === 'rack' ? P.capacity(s, 'v') : null;
    if (!isNum(o.s25)) o.s25 = s.art === 'kanister' ? P.capacity(s, 's25') : null;
    if (!isNum(o.s05)) o.s05 = s.art === 'kanister' ? P.capacity(s, 's50') : null;
    if (s.art === 'rack') { o.racks = 0; s.positionen.forEach(function (p) { o.racks += p.anzahl; }); if (!isNum(o.boxes)) { o.boxes = 0; s.positionen.forEach(function (p) { o.boxes += p.anzahl * p.ebenen_nutzbar; }); } }
    else { o.cans = 0; o.places = 0; s.positionen.forEach(function (p) { o.cans += p.anzahl; o.places += p.anzahl * (p.goblets_je_kanister || 0); }); if (!isNum(o.goblets)) o.goblets = o.places; }
    o.vialsOpen = s.art === 'kanister' && !isNum(s.summe.vials);
    return o;
  }
  CF.sums = sums;
  function cur() {
    var v = pickVariant(S.sel) || CF.variants[0];
    var M = modelOf(v), sys = systemOf(v);
    return { v: v, M: M, sys: sys, sm: sums(sys), mf: v.mf || {}, product: CF.products[v.pid] };
  }
  CF.cur = cur;
  function name(c) { return (c || cur()).M.name || (c || cur()).product.title; }
  CF.name = name;
  /* Wert mit Einheit oder "Wert folgt" */
  function val(x, unit, dec) { return isNum(x) ? fmt(dec ? Math.round(x * Math.pow(10, dec)) / Math.pow(10, dec) : x) + (unit ? ' ' + unit : '') : null; }
  CF.val = val;
  function usable(c) {
    var arr = c.M.nutzhoehe_mm;
    if (arr && arr.length > 1) return arr.length + '×' + arr[0];
    if (isNum(c.mf.usable_height_mm)) return fmt(c.mf.usable_height_mm);
    if (arr && arr.length) return fmt(arr[0]);
    return null;
  }
  CF.usable = usable;
  function usableLong(c) { var arr = c.M.nutzhoehe_mm; if (arr && arr.length > 1) return arr.length + ' × ' + fmt(arr[0]) + ' mm'; var u = usable(c); return u ? u + ' mm' : null; }
  CF.usableLong = usableLong;
  function primary(c) {
    var s = c.sm; if (!s) return null;
    if (c.sys.art === 'rack') return isNum(s.vials) ? { n: s.vials, u: T('unit.vials') } : null;
    if (isNum(s.s25)) return { n: s.s25, u: T('unit.straws') };
    if (isNum(s.goblets)) return { n: s.goblets, u: T('unit.goblets') };
    return null;
  }
  CF.primary = primary;
  function sysKind(c) { return c.sys ? c.sys.art : null; }
  CF.sysKind = sysKind;

  /* Bildgruppe der Variante (Regel Variantenbilder) */
  function gallery(v) {
    var p = CF.products[v.pid], all = p.media || [], vm = p.vmedia || {}, byId = {};
    all.forEach(function (m) { byId[m.id] = m; });
    var main = vm.v && vm.v[v.id], ids = main && vm.g && vm.g[main];
    if (!ids || !ids.length) return all;
    return ids.map(function (i) { return byId[i]; }).filter(Boolean);
  }
  CF.gallery = gallery;
  var thumb = function (src, w) { return String(src).replace(/([?&])width=\d+/, '$1width=' + w); };
  CF.thumb = thumb;

  /* ---------- Rückmeldung nach Auswahländerung ---------- */
  var lastKey = '';
  function changed() {
    var c = cur(); S.vid = c.v.id;
    try {
      var u = new URL(location.href);
      u.searchParams.set('variant', c.v.id);
      var base = c.v.purl;
      if (base && c.v.pid !== CF.D.product.id && u.pathname !== base) u.pathname = base;
      else if (base && c.v.pid === CF.D.product.id && u.pathname !== base) u.pathname = base;
      history.replaceState(null, '', u.pathname + u.search + u.hash);
    } catch (e) { /* ohne Adresszeile weiter */ }
    renderAll();
    if (window.CryonosAuswahl) window.CryonosAuswahl.update(true);
    document.dispatchEvent(new CustomEvent('freezer:change', { detail: { variant: c.v.id } }));
  }
  function renderAll() { Object.keys(CF.renderers).forEach(function (k) { try { CF.renderers[k](); } catch (e) { console.error('freezer render ' + k, e); } }); }
  CF.changed = changed; CF.renderAll = renderAll;

  /* ---------- Bild-Zuschnitt: Gerät im Bild finden (transparente oder weiße Ränder) ---------- */
  var bboxCache = {};
  function bboxOf(img) {
    var key = img.currentSrc || img.src;
    if (bboxCache[key]) return bboxCache[key];
    var res = { x0: 0, y0: 0, x1: 1, y1: 1, cut: false };
    try {
      var w = 96, h = Math.max(1, Math.round(96 * img.naturalHeight / img.naturalWidth)), cv = document.createElement('canvas');
      cv.width = w; cv.height = h;
      var cx = cv.getContext('2d', { willReadFrequently: true }); cx.drawImage(img, 0, 0, w, h);
      var d = cx.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
        var i = (y * w + x) * 4, a = d[i + 3];
        if (a > 40 && !(d[i] > 244 && d[i + 1] > 244 && d[i + 2] > 244)) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
      if (x1 >= 0) { res = { x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h }; res.cut = (res.x1 - res.x0) * (res.y1 - res.y0) < 0.6; }
    } catch (e) { /* Bild nicht lesbar: ganzes Bild */ }
    bboxCache[key] = res;
    return res;
  }
  /* Bild in die Box einpassen: Gerät so groß wie möglich, unten bündig (cut) bzw. mittig (Foto). */
  function fit(img, box, opts) {
    opts = opts || {};
    var W = box.clientWidth, H = box.clientHeight;
    if (!W || !H || !img.naturalWidth) return null;
    var b = bboxOf(img), iw = img.naturalWidth, ih = img.naturalHeight;
    if (!b.cut) b = { x0: 0, y0: 0, x1: 1, y1: 1, cut: false };
    var bw = b.x1 - b.x0, bh = b.y1 - b.y0;
    var s = Math.min(W / (bw * iw), H / (bh * ih));
    var s0 = Math.min(W / iw, H / ih);
    if (s > s0 * (opts.maxZoom || 2.6)) s = s0 * (opts.maxZoom || 2.6);
    var dw = iw * s, dh = ih * s;
    var left = W / 2 - (b.x0 + bw / 2) * dw;
    var top = b.cut ? (H - b.y1 * dh) - Math.max(0, (H - bh * dh)) * (opts.lift == null ? 0.35 : opts.lift) : (H - dh) / 2;
    img.style.width = dw + 'px'; img.style.height = dh + 'px'; img.style.left = left + 'px'; img.style.top = top + 'px';
    return { x0: left + b.x0 * dw, y0: top + b.y0 * dh, x1: left + b.x1 * dw, y1: top + b.y1 * dh, cut: b.cut };
  }
  CF.fit = fit;
  function whenLoaded(img, fn) { if (img.complete && img.naturalWidth) fn(); else img.addEventListener('load', fn, { once: true }); }
  CF.whenLoaded = whenLoaded;

  /* ---------- Hero ---------- */
  var HERO = null;
  function icoKar(n) { return n > 1 ? '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="10" y="6" width="28" height="36" rx="4"/><path d="M10 24h28"/><path d="M16 10v10M22 10v10M28 10v10M34 10v10M16 28v10M22 28v10M28 28v10M34 28v10" stroke-width="1"/></svg>' : '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="10" y="6" width="28" height="36" rx="4"/><path d="M16 12v24M22 12v24M28 12v24M34 12v24" stroke-width="1"/></svg>'; }
  var ICO_SYS = {
    rack: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="24" cy="24" r="20"/><rect x="13" y="13" width="9" height="9"/><rect x="26" y="13" width="9" height="9"/><rect x="13" y="26" width="9" height="9"/><rect x="26" y="26" width="9" height="9"/></svg>',
    kanister: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="24" cy="24" r="20"/><circle cx="24" cy="11" r="3.4"/><circle cx="35" cy="17.5" r="3.4"/><circle cx="35" cy="30.5" r="3.4"/><circle cx="24" cy="37" r="3.4"/><circle cx="13" cy="30.5" r="3.4"/><circle cx="13" cy="17.5" r="3.4"/><circle cx="24" cy="24" r="3.4"/></svg>',
    ohne: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="24" cy="24" r="20"/><circle cx="24" cy="24" r="8" stroke-dasharray="3 3"/></svg>'
  };
  CF.ico = { kar: icoKar, sys: ICO_SYS };

  /* Werte für die Kacheln */
  function sysTileInfo(value, c) {
    /* Lagersystem-Datensatz, der zu Modell (+ Phase) und Art passt */
    var list = systemsOfModel(c.M, S.sel.phase).filter(function (s) { return s.art === value; });
    return list.length ? { sys: list[0], sm: sums(list[0]) } : null;
  }
  function modelTop(role, value) {
    /* "bis 123.690 Straws" je Karussell-Kachel: bestes Straw- bzw. Vial-Ergebnis des Modells */
    var M = CF.D.cfg.modelle[value] || {}, best = null;
    systemsOfModel(M).forEach(function (s) { var m = sums(s); if (s.art === 'kanister' && isNum(m.s25)) best = { n: m.s25, u: T('unit.straws') }; else if (!best && isNum(m.vials)) best = { n: m.vials, u: T('unit.vials') }; });
    return best;
  }

  function stepHead(i, key, sum) { return '<header><b><em>' + (i < 9 ? '0' : '') + (i + 1) + '</em>' + esc(T(key)) + '</b><span>' + (sum == null ? '' : esc(sum)) + '</span></header>'; }

  function renderSteps() {
    var c = cur(), el = $('[data-slot="steps"]', HERO), h = '', n = 0;
    var values = function (role) { var seen = [], out = []; CF.variants.forEach(function (v) { if (v.r[role] != null && seen.indexOf(v.r[role]) < 0) { seen.push(v.r[role]); out.push(v.r[role]); } }); return out; };
    if (CF.roles.indexOf('kar') > -1) {
      var vs = values('kar');
      h += '<div class="frz-step">' + stepHead(n++, 'cfg.kar.title', usableLong(c) || T('common.tbd')) + '<div class="frz-tiles" style="--n:' + vs.length + '">' +
        vs.map(function (k) {
          var M = CF.D.cfg.modelle[k] || {}, top = modelTop('kar', k), lv = Number(M.ebenen) || 1;
          var us = M.nutzhoehe_mm && M.nutzhoehe_mm.length > 1 ? M.nutzhoehe_mm.length + ' × ' + fmt(M.nutzhoehe_mm[0]) + ' mm' : (function () { var any = CF.variants.filter(function (v) { return v.r.kar === k && isNum(v.mf.usable_height_mm); })[0]; return any ? fmt(any.mf.usable_height_mm) + ' mm' : (M.nutzhoehe_mm && M.nutzhoehe_mm[0] ? fmt(M.nutzhoehe_mm[0]) + ' mm' : null); })();
          return '<button type="button" class="frz-tile" data-role="kar" data-val="' + esc(k) + '" aria-pressed="' + (S.sel.kar === k) + '"' + (isDisabled('kar', k) ? ' disabled' : '') + '>' + icoKar(lv) + '<b>' + esc(T(lv > 1 ? 'cfg.kar.tile_n' : 'cfg.kar.tile_1', { n: lv, model: M.name || k })) + '</b><small>' + (us ? esc(T('cfg.kar.usable', { h: us })) : tbd()) + '</small><span class="frz-val">' + (top ? esc(T('cfg.up_to', { n: fmt(top.n), u: top.u })) : tbd()) + '</span></button>';
        }).join('') + '</div></div>';
    }
    ['phase', 'medium'].forEach(function (role) {
      if (CF.roles.indexOf(role) < 0) return;
      var vs = values(role);
      h += '<div class="frz-step">' + stepHead(n++, 'cfg.' + role + '.title', T('cfg.' + role + '.' + S.sel[role])) + '<div class="frz-segm">' + vs.map(function (k) {
        return '<button type="button" data-role="' + role + '" data-val="' + esc(k) + '" aria-pressed="' + (S.sel[role] === k) + '"' + (isDisabled(role, k) ? ' disabled' : '') + '><span><b>' + esc(T('cfg.' + role + '.' + k)) + '</b></span></button>';
      }).join('') + '</div></div>';
    });
    if (CF.roles.indexOf('sys') > -1) {
      var ss = values('sys');
      h += '<div class="frz-step">' + stepHead(n++, 'cfg.sys.title', c.sys ? T('sys.' + c.sys.art + '.name') : T('sys.ohne.name')) + '<div class="frz-tiles" style="--n:' + ss.length + '">' + ss.map(function (k) {
        var info = k === 'ohne' ? null : sysTileInfo(k, c), dis = isDisabled('sys', k), valHtml = '';
        if (k === 'ohne') valHtml = '–';
        else if (!info) valHtml = esc(T('cfg.sys.not_with', { model: c.M.name }));
        else if (k === 'rack') valHtml = isNum(info.sm.vials) ? esc(fmt(info.sm.vials) + ' ' + T('unit.vials')) : tbd();
        else valHtml = (isNum(info.sm.s25) ? esc(fmt(info.sm.s25) + ' ' + T('unit.straws')) : (isNum(info.sm.goblets) ? esc(fmt(info.sm.goblets) + ' ' + T('unit.goblets')) : tbd())) + (info.sm.vialsOpen ? '<br>' + esc(T('cfg.plus_vials')) : '');
        return '<button type="button" class="frz-tile" data-role="sys" data-val="' + esc(k) + '" aria-pressed="' + (S.sel.sys === k) + '"' + ((dis || (!info && k !== 'ohne')) ? ' disabled' : '') + '>' + ICO_SYS[k] + '<b>' + esc(T('sys.' + k + '.tile')) + '</b><small>' + esc(T('sys.' + k + '.sub')) + '</small><span class="frz-val">' + valHtml + '</span></button>';
      }).join('') + '</div></div>';
    }
    if (CF.roles.indexOf('fill') > -1) {
      h += '<div class="frz-step">' + stepHead(n++, 'cfg.fill.title', T('cfg.fill.' + S.sel.fill + '_sum')) + '<div class="frz-segm">' + ['auto', 'manuell'].filter(function (k) { return values('fill').indexOf(k) > -1; }).map(function (k) {
        return '<button type="button" data-role="fill" data-val="' + k + '" aria-pressed="' + (S.sel.fill === k) + '"><span><b>' + esc(T('cfg.fill.' + k)) + '</b><br><small>' + esc(T('cfg.fill.' + k + '_sub')) + '</small></span><span class="frz-tag' + (k === 'auto' ? ' inc' : '') + '">' + esc(T('cfg.fill.' + k + '_tag')) + '</span></button>';
      }).join('') + '</div></div>';
    }
    if (CF.hasTwin) {
      h += '<div class="frz-step">' + stepHead(n++, 'cfg.mdr.title', S.sel.mdr ? T('cfg.mdr.mdr_sum') : T('cfg.mdr.std_sum')) + '<div class="frz-segm">' +
        '<button type="button" data-mdr="0" aria-pressed="' + (!S.sel.mdr) + '"><span><b>' + esc(T('cfg.mdr.std')) + '</b><br><small>' + esc(T('cfg.mdr.std_sub')) + '</small></span></button>' +
        '<button type="button" data-mdr="1" aria-pressed="' + (!!S.sel.mdr) + '"><span><b>' + esc(T('cfg.mdr.mdr')) + '</b><br><small>' + esc(T('cfg.mdr.mdr_sub')) + '</small></span></button></div></div>';
    }
    var adds = CF.accCfg ? CF.accCfg() : [];
    if (adds.length) { h += '<div class="frz-step">' + stepHead(n++, 'cfg.adds.title', null).replace('<span></span>', '<span>' + esc(T('cfg.adds.meta')) + '</span>') + '<div class="frz-adds" data-slot="adds"></div></div>'; }
    el.innerHTML = h;
    if (adds.length) renderAdds(adds);
  }

  /* Zubehör-Checkliste im Konfigurator (aus #frz-acc, Blöcke der Zubehör-Section mit "im Konfigurator anbieten") */
  /* HOTFIX 22.10.2026 (AUFTRAG-97 A): Einträge mit „Ausführung muss zum Modell passen“ (match) zeigen nur die Ausführung(en), deren Name die
     Nenngröße des gewählten Modells als eigene Zahl trägt (Tritt: „AC FREEZER 430“ / „860“). Passt keine (z. B. SYS 480), entfällt der Eintrag
     ganz (Karte, Konfigurator, Warenkorb, Anfrage). Aus den Daten (ln2_capacity_liter + Ausführungsnamen), keine Handles. */
  /* 22.10.2026 (Prüflauf 1 AUFTRAG-97): Nenngröße aus dem Modellnamen (Regel „Zahlen = Nennwerte aus dem Modellnamen“), nicht aus
     ln2_capacity_liter (fehlt im Testshop beim 430, ist beim 860 ein Objekt {value,unit}). */
  function modelZahl(c) { var m = String(name(c) || "").match(/(^|\D)(\d{3,4})(\D|$)/); return m ? m[2] : null; }
  function accItems() {
    var all = (CF.ACC && CF.ACC.items) || [], cap = null;
    try { cap = modelZahl(cur()); } catch (e) { cap = null; }
    var re = cap ? new RegExp('(^|\\D)' + cap + '(\\D|$)') : null;
    return all.filter(function (a) {
      if (!a.match) return true;
      if (!a._all) a._all = a.variants.slice();
      if (a._all.length < 2) return true;
      a.variants = re ? a._all.filter(function (v) { return re.test(v.title); }) : [];
      return a.variants.length > 0;
    });
  }
  CF.accFits = function (key) { return accItems().some(function (a) { return a.key === key; }); };
  /* Gibt es Einträge mit „passt zum Modell“, aber keiner passt zum gewählten Modell? Dann entfällt auch die zugehörige Markierung im Foto. */
  CF.accMatchMissing = function () { var all = (CF.ACC && CF.ACC.items) || []; var m = all.filter(function (a) { return a.match; }); return m.length > 0 && !m.some(function (a) { return CF.accFits(a.key); }); };
  CF.accCfg = function () { return accItems().filter(function (a) { return a.cfg && !(a.fill === 'manuell' && S.sel.fill === 'auto') && !(a.fill === 'auto' && S.sel.fill !== 'auto'); }); };
  function accState(a) {
    var st = S.adds[a.key];
    if (!st) { st = S.adds[a.key] = { on: !!a.pre, vid: null }; }
    /* SOFORT 21.10.2026: Vorauswahl = Variante mit der Modellgröße als eigener Zahl im Namen (z. B. „AC FREEZER 430“ auf der 430-Seite).
       Block-Einstellung „Ausführung muss zum Modell passen“ (match): ohne passende Variante keine Vorauswahl (statt still die erste). */
    if (st.vid && !a.variants.some(function (v) { return v.id === st.vid; })) st.vid = null; /* Modellwechsel: alte Ausführung passt nicht mehr */
    if (!st.vid) {
      var c = cur(), cap = modelZahl(c);
      var re = cap ? new RegExp('(^|\\D)' + cap + '(\\D|$)') : null;
      var hit = re ? a.variants.filter(function (v) { return re.test(v.title); })[0] : null;
      st.vid = hit ? hit.id : (a.match && a.variants.length > 1 ? null : (a.variants[0] ? a.variants[0].id : null));
    }
    return st;
  }
  CF.accState = accState;
  function accReq(a) { return a.need === 'auto' ? S.sel.fill === 'auto' : a.need === 'always'; }
  CF.accReq = accReq;
  function renderAdds(adds) {
    var el = $('[data-slot="adds"]', HERO);
    el.innerHTML = adds.map(function (a) {
      var st = accState(a), req = accReq(a);
      if (req && st.forced !== S.sel.fill) { st.on = true; st.forced = S.sel.fill; }
      if (!req) st.forced = null;
      var sel = a.variants.length > 1 ? '<select data-add-var="' + esc(a.key) + '" aria-label="' + esc(a.title) + '"' + (st.vid ? '' : ' required') + '>' + (st.vid ? '' : '<option value="" selected disabled>–</option>') + a.variants.map(function (v) { return '<option value="' + v.id + '"' + (v.id === st.vid ? ' selected' : '') + '>' + esc(v.title) + '</option>'; }).join('') + '</select>' : '';
      return '<label class="frz-add' + (req ? ' req' : '') + '"><input type="checkbox" data-add="' + esc(a.key) + '"' + (st.on ? ' checked' : '') + '>' + (a.img ? '<img src="' + esc(thumb(a.img, 120)) + '" alt="" aria-hidden="true" loading="lazy" width="44" height="44">' : '<span></span>') + '<span><b>' + esc(a.title) + '</b><small>' + esc(a.sub || '') + '</small>' + sel + '</span>' + (req ? '<span class="frz-tag req">' + esc(T('cfg.adds.req_cf')) + '</span>' : (a.need === 'recommended' ? '<span class="frz-tag rec">' + esc(T('tag.recommended')) + '</span>' : '<span class="frz-tag">' + esc(T('cfg.adds.optional')) + '</span>')) + '</label>';
    }).join('');
  }

  function addsTotal() {
    var total = 0, list = [];
    accItems().forEach(function (a) { if (!a.cfg) return; var st = S.adds[a.key]; if (!st || !st.on) return; if (CF.accCfg().indexOf(a) < 0) return; var v = a.variants.filter(function (x) { return x.id === st.vid; })[0] || (a.match ? null : a.variants[0]); if (!v) return; total += v.price; list.push({ a: a, v: v }); });
    return { total: total, list: list };
  }
  CF.addsTotal = addsTotal;

  /* 21.10.2026 (Befund 5): Menge wie auf der Produktseite v60; gilt für Gerät und alle angehakten Zubehörteile. */
  function qty() { var i = $('[data-frz-qty-input]', HERO); var n = i ? parseInt(i.value, 10) : 1; return n > 0 ? n : 1; }
  CF.qty = qty;

  function quoteUrl(extra) {
    var q = qty(), c = cur(), base = CF.D.urls.quote || '/pages/request-a-quote', items = [c.v.id + ':' + q + ':' + c.v.handle];
    addsTotal().list.forEach(function (x) { items.push(x.v.id + ':' + q + ':' + (x.v.handle || x.a.handle)); });
    var u = base + (base.indexOf('?') > -1 ? '&' : '?') + 'items=' + encodeURIComponent(items.join(',')).replace(/%3A/g, ':').replace(/%2C/g, ',') + '&src=product';
    return u + (extra || '');
  }
  CF.quoteUrl = quoteUrl;

  function renderKeys(c) {
    var mf = c.mf, p = primary(c);
    var cell = function (label, valHtml, me) { return '<div class="' + (me ? 'me' : '') + '"><small>' + esc(label) + '</small><b>' + valHtml + '</b></div>'; };
    var v = function (x, unit, group) { return isNum(x) ? esc(fmt(x)) + '<i>' + esc(unit) + '</i>' : tbd(); };
    var us = usable(c);
    $('[data-slot="keys"]', HERO).innerHTML =
      cell(T('keys.ln2'), v(mf.ln2_capacity_liter, 'l')) + cell(T('keys.evap'), v(mf.evaporation_rate_liter_day, T('unit.l_day'))) + cell(T('keys.neck'), v(mf.neck_opening_mm, 'mm')) +
      cell(T('keys.usable'), us ? esc(us) + '<i>mm</i>' : tbd()) + cell(T('keys.od'), v(mf.outside_diameter_mm, 'mm')) + cell(T('keys.height'), v(mf.total_height_mm, 'mm')) +
      cell(T('keys.weight'), v(mf.empty_weight_kg, 'kg')) + cell(T('keys.sel'), p ? esc(fmt(p.n)) + '<i>' + esc(p.u) + '</i>' : (c.sys ? tbd() : '–'), true);
  }

  function renderSum(c) {
    var at = addsTotal(), n = at.list.length;
    var q = qty();
    $('[data-slot="sumtxt"]', HERO).textContent = T('sum.line', { model: name(c) + (c.v.mdr ? ' MDR' : '') }).replace(/^1(\s*×)/, q + '$1') + (n ? ' ' + T('sum.plus', { n: n }) : '');
    var total = (c.v.price + at.total) * q;
    $('[data-slot="price"]', HERO).textContent = money(total);
    var f = $('[data-frz-form]', HERO); if (f) { var id = f.querySelector('[name="id"]'); if (id) id.value = c.v.id; }
    var btn = $('[data-act="cart"]', HERO); if (btn) { btn.disabled = !c.v.available; btn.textContent = c.v.available ? T('sum.cart') : T('sum.unavailable'); }
    $$('[data-quote-link]').forEach(function (a) { a.setAttribute('href', quoteUrl()); });
    var sb = $('[data-frz-sbar]');
    if (sb) {
      var g = gallery(c.v)[0]; var im = $('img', sb); if (im && g) { im.src = thumb(g.src, 160); im.alt = ''; }
      $('[data-slot="sb-name"]', sb).textContent = name(c) + (c.v.mdr ? ' MDR' : '');
      $('[data-slot="sb-sub"]', sb).textContent = (c.sys ? T('sys.' + c.sys.art + '.name') : T('sys.ohne.name')) + ' · ' + (c.v.r.fill === 'auto' ? T('cfg.fill.auto') : T('cfg.fill.manuell_short'));
      var sbb = $('[data-act="cart"]', sb); if (sbb) { sbb.disabled = !c.v.available; }
    }
  }

  /* Bühne */
  function renderStage(c) {
    var stage = $('[data-slot="stage"]', HERO), g = gallery(c.v), slides = $('[data-slot="slides"]', stage);
    S.slide = Math.min(S.slide || 0, Math.max(0, g.length - 1));
    var sig = g.map(function (m) { return m.id; }).join(',');
    if (slides.dataset.sig !== sig) {
      slides.dataset.sig = sig;
      slides.innerHTML = g.map(function (m, i) { return '<div class="frz-sl"><div class="frz-sl__box"><img src="' + esc(m.src) + '" alt="' + esc(m.alt || (name(c) + ' ' + (i + 1))) + '" crossorigin="anonymous" ' + (i === 0 ? 'fetchpriority="high"' : 'loading="lazy"') + ' decoding="async"></div></div>'; }).join('');
      $('[data-slot="thumbs"]', stage).innerHTML = g.map(function (m, i) { return '<button type="button" data-i="' + i + '" aria-label="' + esc(T('stage.image_n', { n: i + 1 })) + '"><img src="' + esc(thumb(m.src, 160)) + '" alt="" aria-hidden="true" loading="lazy"></button>'; }).join('');
      $$('.frz-sl img', slides).forEach(function (im) { whenLoaded(im, function () { layoutSlide(im.closest('.frz-sl')); }); });
    }
    $$('.frz-sl', slides).forEach(function (s, i) { s.classList.toggle('on', i === S.slide); s.setAttribute('aria-hidden', i === S.slide ? 'false' : 'true'); });
    $$('[data-slot="thumbs"] button', stage).forEach(function (b, i) { b.setAttribute('aria-current', i === S.slide ? 'true' : 'false'); });
    var cntEl = $('[data-slot="cnt"]', stage);
    cntEl.innerHTML = '<b>' + (S.slide + 1) + '</b> / ' + g.length;
    var multi = g.length > 1; $$('.frz-arw', stage).forEach(function (b) { b.hidden = !multi; });
    cntEl.hidden = !multi;
    revealThumb(stage);
    renderDims(c);
  }
  /* AUFTRAG-92: Vorschaubild-Reihe – Pfeile und Ausblenden nur, wenn Bilder abgeschnitten sind; aktives Bild wird in die Reihe gescrollt. */
  var frzReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function thumbArrows(stage) {
    var tw = $('[data-slot="thumbs"]', stage); if (!tw) return;
    var max = tw.scrollWidth - tw.clientWidth, l = max > 2 && tw.scrollLeft > 2, r = max > 2 && tw.scrollLeft < max - 2;
    var p = $('[data-frz-tprev]', stage), n = $('[data-frz-tnext]', stage);
    var over = max > 2; /* bei Überlauf behalten beide Pfeile ihren Platz; der am Ende wird nur unsichtbar (.is-off) */
    if (p) { p.hidden = !over; p.classList.toggle('is-off', !l); } if (n) { n.hidden = !over; n.classList.toggle('is-off', !r); }
    tw.classList.toggle('is-more-l', l); tw.classList.toggle('is-more-r', r);
  }
  function revealThumb(stage) {
    var tw = $('[data-slot="thumbs"]', stage), a = tw && $('button[aria-current="true"]', tw);
    if (a && a.offsetParent !== null) {
      var left = a.getBoundingClientRect().left - tw.getBoundingClientRect().left + tw.scrollLeft, right = left + a.offsetWidth, b = frzReduce.matches ? 'instant' : 'smooth';
      if (left < tw.scrollLeft + 32) tw.scrollTo({ left: Math.max(0, left - 32), behavior: b });
      else if (right > tw.scrollLeft + tw.clientWidth - 32) tw.scrollTo({ left: right - tw.clientWidth + 32, behavior: b });
    }
    thumbArrows(stage);
  }
  function bindThumbStrip() {
    var stage = $('[data-slot="stage"]', HERO), tw = stage && $('[data-slot="thumbs"]', stage);
    if (!tw || tw._frzBound) return; tw._frzBound = true;
    tw.addEventListener('scroll', function () { thumbArrows(stage); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(function () { thumbArrows(stage); }).observe(tw);
    stage.addEventListener('click', function (e) {
      var t = e.target.closest('.frz-tarw'); if (!t) return;
      tw.scrollBy({ left: (t.classList.contains('prev') ? -1 : 1) * Math.max(60, tw.clientWidth * 0.8), behavior: frzReduce.matches ? 'instant' : 'smooth' });
    });
    stage.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (!e.target.closest('.frz-thumbs button, .frz-arw')) return;
      var g = gallery(cur().v), n = g.length; if (n < 2) return;
      e.preventDefault();
      S.slide = (S.slide + (e.key === 'ArrowRight' ? 1 : -1) + n) % n; renderStage(cur());
      if (e.target.closest('.frz-thumbs button')) { var a = $('.frz-thumbs button[aria-current="true"]', stage); if (a) a.focus({ preventScroll: true }); }
    });
  }
  function layoutSlide(s) {
    if (!s) return;
    var box = $('.frz-sl__box', s), im = $('img', box); if (!im) return;
    var r = fit(im, box, { maxZoom: 2.6, lift: 0 });
    s._rect = r;
    if (s.classList.contains('on')) renderDims();
  }
  function renderDims(c) {
    var stage = $('[data-slot="stage"]', HERO), el = $('[data-slot="dims"]', stage); c = c || cur();
    var s = $$('.frz-sl', stage)[S.slide], r = s && s._rect, mf = c.mf;
    if (!r || !r.cut || !S.dims) { el.innerHTML = ''; return; }
    var box = $('.frz-sl__box', s), bx = box.getBoundingClientRect(), st = el.getBoundingClientRect();
    var ox = bx.left - st.left, oy = bx.top - st.top, id = 'st';
    var x0 = ox + r.x0, x1 = ox + r.x1, y0 = oy + r.y0, y1 = oy + r.y1, cx = (x0 + x1) / 2, w = st.width, hh = st.height;
    var neckW = isNum(mf.neck_opening_mm) && isNum(mf.outside_diameter_mm) ? (x1 - x0) * (mf.neck_opening_mm / mf.outside_diameter_mm) : 0;
    var h = '<svg width="' + w + '" height="' + hh + '" viewBox="0 0 ' + w + ' ' + hh + '" aria-hidden="true">' + defs(id);
    if (isNum(mf.outside_diameter_mm)) h += dim(id, x0 + (x1 - x0) * 0.12, y1 + 18, x1 - (x1 - x0) * 0.12, y1 + 18, 'Ø ' + fmt(mf.outside_diameter_mm));
    if (isNum(mf.total_height_mm)) h += dim(id, x1 + 16, y0, x1 + 16, y1, fmt(mf.total_height_mm), 14);
    if (isNum(mf.neck_opening_mm) && neckW) h += dim(id, cx - neckW / 2, y0 + (y1 - y0) * 0.08, cx + neckW / 2, y0 + (y1 - y0) * 0.08, 'Ø ' + fmt(mf.neck_opening_mm), -8);
    el.innerHTML = h + '</svg>';
  }

  function renderHero() {
    var c = cur();
    var nm = name(c), m = /^(.*?)(\d+)(\D*)$/.exec(nm);
    $('[data-slot="name"]', HERO).innerHTML = m ? esc(m[1]) + '<span>' + esc(m[2]) + '</span>' + esc(m[3]) : esc(nm);
    $('[data-slot="crumb"]', HERO).textContent = nm;
    $('[data-slot="sub"]', HERO).innerHTML = '<b>' + esc(nm + (c.v.mdr ? ' MDR' : '')) + '</b> · ' + esc(c.sys ? T('sys.' + c.sys.art + '.short') : T('sys.ohne.short')) + ' · ' + esc(c.v.r.fill === 'auto' ? T('cfg.fill.with_cf') : T('cfg.fill.manual_text'));
    var badge = $('[data-slot="badge"]', HERO); if (badge) badge.hidden = !CF.mdrAvailable;
    renderKeys(c); renderSteps(); renderSum(c); renderStage(c);
    $$('[data-datasheet-link]').forEach(function (a) { var u = c.product.datasheet || (CF.D.product.datasheet) || ''; a.hidden = !u; if (u) a.setAttribute('href', u); });
  }

  /* ---------- Überblick ---------- */
  function renderOverview() {
    var root = $('[data-frz="overview"]'); if (!root) return;
    var vars_cans = '', vars_places = '', c = cur(), mf = c.mf, sm = c.sm, M = c.M, prof = M.profil || 'bio', nm = name(c);
    var all = systemsOfModel(M).map(sums), maxV = 0, maxS = 0, lv = '';
    all.forEach(function (s) { if (isNum(s.vials) && s.vials > maxV) maxV = s.vials; if (isNum(s.s25) && s.s25 > maxS) maxS = s.s25; });
    var kn = systemsOfModel(M).filter(function (s) { return s.art === 'kanister'; })[0]; if (kn) { var ks = sums(kn); vars_cans = fmt(ks.cans); vars_places = kn.positionen[0].goblets_je_kanister; }
    var rack = all.filter(function (s) { return s.racks; })[0]; if (rack) { var rs = systemsOfModel(M).filter(function (s) { return s.art === 'rack'; })[0]; lv = rs && rs.positionen[0] ? rs.positionen[0].ebenen_nutzbar : ''; }
    var vars = { model: nm, vials: maxV ? fmt(maxV) : '', straws: maxS ? fmt(maxS) : '', ln2: isNum(mf.ln2_capacity_liter) ? fmt(mf.ln2_capacity_liter) : '', evap: isNum(mf.evaporation_rate_liter_day) ? fmt(mf.evaporation_rate_liter_day) : '', neck: isNum(mf.neck_opening_mm) ? fmt(mf.neck_opening_mm) : '', levels: lv, usable: M.nutzhoehe_mm && M.nutzhoehe_mm[0] ? fmt(M.nutzhoehe_mm[0]) : '', n: M.nutzhoehe_mm ? M.nutzhoehe_mm.length : 1, cans: '', places: '' };
    vars.cans = vars_cans; vars.places = vars_places;
    var leadKey = 'model.' + prof + '.lead' + (maxV && maxS ? '_both' : (maxV ? '_vials' : '_straws'));
    $('[data-slot="ovlead"]', root).innerHTML = esc(has(leadKey) ? T(leadKey, vars) : T('model.' + prof + '.lead', vars)).replace(/\*\*(.+?)\*\*/g, '<em>$1</em>');
    var auto = c.v.r.fill === 'auto', tx = $('[data-slot="ovtext"]', root); if (tx) tx.textContent = T(auto ? 'ov.text_auto' : 'ov.text_man', vars);
    var ben = [T('ov.ben1', vars), T('model.' + prof + '.ben2', vars), T('model.' + prof + '.ben3', vars), T(auto ? 'ov.ben4_auto' : 'ov.ben4_man', vars)].filter(function (x) { return x && !/\{\w+\}/.test(x); });
    $('[data-slot="ben"]', root).innerHTML = ben.map(function (b, i) { return '<li><i>0' + (i + 1) + '</i><span>' + esc(b) + '</span></li>'; }).join('');
    var yes = $('[data-slot="mdryes"]', root);
    if (yes) yes.innerHTML = !CF.hasTwin ? (S.sel.mdr ? esc(T('ov.mdr_yes')) : '') : (S.sel.mdr ? '✓ ' + esc(T('ov.mdr_yes')) : '○ ' + esc(T('ov.mdr_no')) + ' · <a href="#top" data-setmdr>' + esc(T('ov.mdr_pick')) + '</a>');
    var note = $('[data-slot="gas"]', root); if (note) note.innerHTML = '<b>' + esc(T('ov.gas_h')) + '</b><br>' + esc(T('ov.gas_t', vars));
    var mc = $('[data-slot="mdrcard"]', root); if (mc) mc.hidden = !CF.mdrAvailable;
  }

  /* ---------- Anlage ---------- */
  function renderAnlage() {
    var root = $('[data-frz="anlage"]'); if (!root) return;
    var c = cur(), auto = c.v.r.fill === 'auto', sys = c.sys, id = 'sy' + (++uid % 3), nm = name(c), hl = S.hl || 0, mf = c.mf;
    $('[data-slot="alead"]', root).textContent = auto ? T('anl.lead_auto') : T('anl.lead_manual');
    $('[data-slot="asys"]', root).textContent = nm + ' · ' + (auto ? T('cfg.fill.auto_short') : T('cfg.fill.manuell_short'));
    var inner = '';
    if (sys && sys.art === 'rack') {
      var nR = Math.min(6, Math.max(2, Math.round(sums(sys).racks / 2.6)));
      for (var i = 0; i < nR; i++) { inner += '<rect x="' + (478 + i * 30) + '" y="236" width="20" height="132" fill="none" stroke="' + K.acc + '"/>'; for (var j = 0; j < 12; j++) inner += '<line x1="' + (478 + i * 30) + '" x2="' + (498 + i * 30) + '" y1="' + (246 + j * 10) + '" y2="' + (246 + j * 10) + '" stroke="' + K.acc + '" stroke-width=".6" opacity=".6"/>'; }
    } else if (sys) {
      var lvls = Math.max(1, Number(c.M.ebenen) || 1);
      for (var r = 0; r < lvls; r++) for (var q = 0; q < 9; q++) inner += '<rect x="' + (476 + q * 20) + '" y="' + (236 + r * 68) + '" width="12" height="' + (lvls > 1 ? 58 : 132) + '" rx="5" fill="none" stroke="' + K.acc + '"/>';
    } else inner = '<text x="565" y="306" text-anchor="middle" fill="' + K.mu + '" font-size="12" font-family="Inter,Arial">' + esc(T('anl.own_system')) + '</text>';
    var ring = function (n, x, y) { return hl === n ? '<circle cx="' + x + '" cy="' + y + '" r="16" fill="none" stroke="' + K.acc + '" stroke-width="1.5" opacity=".9"/>' : ''; };
    var bub = function (n, x, y) { return '<g>' + ring(n, x, y) + '<circle cx="' + x + '" cy="' + y + '" r="11" fill="' + K.acc + '"/><text x="' + x + '" y="' + (y + 4) + '" text-anchor="middle" font-size="11" font-weight="900" font-family="Archivo,Arial" fill="#0b0d10">' + n + '</text></g>'; };
    $('[data-slot="asvg"]', root).innerHTML = '<svg viewBox="0 0 760 470" role="img" aria-label="' + esc(T('anl.svg_label')) + '">' + defs(id) +
      '<line x1="30" y1="430" x2="740" y2="430" stroke="' + K.lo + '"/>' +
      '<path d="M90 205 Q90 182 113 182 H187 Q210 182 210 205 V410 Q210 420 200 420 H100 Q90 420 90 410 Z" fill="url(#' + id + 's)" stroke="' + K.ln + '" stroke-width="1.2"/><rect x="128" y="160" width="44" height="24" rx="4" fill="' + K.fill + '" stroke="' + K.ln + '" stroke-width="1.2"/><path d="M96 300 H204 V410 Q204 416 198 416 H102 Q96 416 96 410 Z" fill="url(#' + id + 'n)"/>' +
      '<path d="M172 168 C 250 80, 360 60, 452 98" fill="none" stroke="' + (auto ? K.acc : K.mu) + '" stroke-width="' + (auto ? 2.2 : 1.4) + '" stroke-dasharray="' + (auto ? '0' : '5 6') + '"/>' +
      '<g opacity="' + (auto ? 1 : 0.3) + '"><line x1="472" y1="118" x2="472" y2="186" stroke="' + K.ln + '" stroke-width="2.4"/><rect x="440" y="80" width="72" height="44" rx="5" fill="' + K.fill + '" stroke="' + K.acc + '" stroke-width="1.2"/><rect x="448" y="88" width="40" height="28" rx="2" fill="' + K.ln2 + '" opacity=".55"/></g>' +
      '<path d="M420 200 Q420 186 434 186 H696 Q710 186 710 200 V412 Q710 420 702 420 H428 Q420 420 420 412 Z" fill="url(#' + id + 's)" stroke="' + K.ln + '" stroke-width="1.2"/><rect x="412" y="176" width="306" height="16" rx="6" fill="' + K.fill + '" stroke="' + K.ln + '" stroke-width="1.2"/>' +
      '<rect x="440" y="222" width="250" height="186" rx="8" fill="#0d1115" stroke="' + K.lo + '"/><rect x="440" y="378" width="250" height="30" rx="6" fill="url(#' + id + 'n)"/>' + inner +
      '<circle cx="112" cy="426" r="5" fill="none" stroke="' + K.ln + '"/><circle cx="188" cy="426" r="5" fill="none" stroke="' + K.ln + '"/><circle cx="440" cy="426" r="5" fill="none" stroke="' + K.ln + '"/><circle cx="565" cy="426" r="5" fill="none" stroke="' + K.ln + '"/><circle cx="690" cy="426" r="5" fill="none" stroke="' + K.ln + '"/>' +
      bub(1, 150, 250) + bub(2, 300, 74) + (auto ? bub(3, 476, 62) : '') + bub(4, 700, 206) + bub(5, 565, 300) + '</svg>';
    var it = [
      [1, T('anl.i1_t'), T('anl.i1_s'), auto ? ['req', T('tag.required')] : ['rec', T('tag.recommended')]],
      [2, T('anl.i2_t'), T('anl.i2_s'), auto ? ['req', T('tag.required')] : ['rec', T('tag.recommended')]],
      [3, T('anl.i3_t'), T('anl.i3_s'), auto ? ['inc', T('tag.included')] : ['', T('tag.retrofit')]],
      [4, nm, T('anl.i4_s', { ln2: isNum(mf.ln2_capacity_liter) ? fmt(mf.ln2_capacity_liter) : T('common.tbd'), od: isNum(mf.outside_diameter_mm) ? fmt(mf.outside_diameter_mm) : T('common.tbd'), neck: isNum(mf.neck_opening_mm) ? fmt(mf.neck_opening_mm) : T('common.tbd') }), ['inc', T('tag.included')]],
      [5, sys ? T('sys.' + sys.art + '.name') : T('sys.ohne.name'), sys ? sysSummary(sys) : T('anl.i5_none'), sys ? ['inc', T('tag.included')] : ['', T('tag.optional')]]
    ];
    var list = $('[data-slot="alist"]', root);
    list.innerHTML = it.filter(function (x) { return auto || x[0] !== 3 || true; }).map(function (x) { return '<button type="button" class="frz-sysi' + (x[3][0] === '' ? ' off' : '') + (hl === x[0] ? ' on' : '') + '" data-hl="' + x[0] + '"><i>' + x[0] + '</i><span><b>' + esc(x[1]) + '</b><small>' + esc(x[2]) + '</small><span class="frz-tag ' + x[3][0] + '">' + esc(x[3][1]) + '</span></span></button>'; }).join('');
  }
  function sysSummary(sys) {
    if (sys.art === 'rack') return sys.positionen.map(function (p) { return T('sys.rack.pos', { n: p.anzahl, box: p.boxtyp, lv: p.ebenen_nutzbar }); }).join(' · ');
    var p = sys.positionen[0]; return p ? T('sys.kanister.pos', { n: p.anzahl, d: p.durchmesser_mm, h: fmt(p.hoehe_mm), g: p.goblets_je_kanister }) : '';
  }
  CF.sysSummary = sysSummary;

  /* ---------- Ereignisse ---------- */
  function bind() {
    document.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-role]')) && t.closest('[data-frz="hero"]') && !t.disabled) { choose(t.dataset.role, t.dataset.val); return; }
      if ((t = e.target.closest('[data-mdr]'))) { setMdr(t.dataset.mdr === '1'); return; }
      if (e.target.closest('[data-setmdr]')) { e.preventDefault(); setMdr(true); var top = $('#top'); if (top) top.scrollIntoView({ behavior: 'smooth' }); return; }
      if ((t = e.target.closest('.frz-thumbs button'))) { S.slide = +t.dataset.i; renderStage(cur()); return; }
      if (e.target.closest('.frz-arw.prev')) { var n = gallery(cur().v).length; S.slide = (S.slide - 1 + n) % n; renderStage(cur()); return; }
      if (e.target.closest('.frz-arw.next')) { var n2 = gallery(cur().v).length; S.slide = (S.slide + 1) % n2; renderStage(cur()); return; }
      if ((t = e.target.closest('[data-act="dims"]'))) { S.dims = !S.dims; t.setAttribute('aria-pressed', S.dims ? 'true' : 'false'); renderDims(); return; }
      if ((t = e.target.closest('[data-hl]')) && t.closest('[data-frz="anlage"]')) { S.hl = S.hl === +t.dataset.hl ? 0 : +t.dataset.hl; renderAnlage(); return; }
    });
    /* Mengenwähler wie v60 (−/+ und Eingabe) */
    var qbox = $('[data-frz-qty]', HERO);
    if (qbox) {
      var qin = $('[data-frz-qty-input]', qbox);
      /* HOTFIX 22.10.2026 (AUFTRAG-97 B): Klick am Dokument abgefangen (nicht am Kasten), damit −/+ auch dann reagieren, wenn der Kasten neu gezeichnet wird;
         die Menge wird frisch aus dem Feld gelesen, ein Fehler in der Summenzeile verhindert die Mengenänderung nicht. */
      document.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-frz-qty] [data-step]'); if (!b) return;
        var inp = $('[data-frz-qty-input]', HERO); if (!inp) return;
        e.preventDefault();
        inp.value = Math.max(1, qty() + Number(b.dataset.step));
        try { renderSum(cur()); auswahlUpdate(); } catch (err) { if (window.console) console.warn('freezer qty', err); }
      });
      if (qin) qin.addEventListener('input', function () { renderSum(cur()); auswahlUpdate(); });
    }
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-frz-qty-input]')) { e.target.value = qty(); renderSum(cur()); auswahlUpdate(); return; }
      var a = e.target.closest('[data-add]');
      if (a) { var st = S.adds[a.dataset.add]; if (st) { st.on = a.checked; if (st.on && !st.vid) { var sv = a.closest('label') && a.closest('label').querySelector('select'); if (sv) sv.focus(); } renderSum(cur()); auswahlUpdate(); } return; }
      var v = e.target.closest('[data-add-var]');
      if (v) { var st2 = S.adds[v.dataset.addVar]; if (st2) { st2.vid = Number(v.value); renderSum(cur()); auswahlUpdate(); } }
    });
    var resizeT; window.addEventListener('resize', function () { clearTimeout(resizeT); resizeT = setTimeout(function () { $$('.frz-sl').forEach(layoutSlide); renderDims(); document.dispatchEvent(new CustomEvent('freezer:resize')); }, 120); });
    /* Warenkorb: Gerät + angehakte Zubehörteile mit einem Aufruf */
    var form = $('[data-frz-form]', HERO);
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = qty(), c = cur(), items = [{ id: c.v.id, quantity: q }];
      addsTotal().list.forEach(function (x) { items.push({ id: x.v.id, quantity: q }); });
      var btn = $('[data-act="cart"]', HERO); if (btn) btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { if (window.CryonosCartDrawer && window.CryonosCartDrawer.refresh) return window.CryonosCartDrawer.refresh(); location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart'; })
        .catch(function () { var m = $('[data-slot="cartmsg"]', HERO); if (m) { m.hidden = false; m.textContent = T('sum.cart_error'); } })
        .then(function () { if (btn) btn.disabled = !cur().v.available; });
    });
    $$('[data-frz-cartbtn]').forEach(function (b) { b.addEventListener('click', function () { if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); }); });
    /* Mitlaufende Leiste, sobald der Konfigurator aus dem Bild ist */
    var sb = $('[data-frz-sbar]'), cfgEl = $('.frz-cfg', HERO);
    if (sb && cfgEl) { var tick = false, upd = function () { tick = false; var past = cfgEl.getBoundingClientRect().bottom < 80; sb.classList.toggle('on', past); sb.setAttribute('aria-hidden', past ? 'false' : 'true'); }; window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true }); upd(); }
  }

  /* ---------- Unternavigation: Links aus den Abschnitten der Seite ---------- */
  function buildNav() {
    var nav = $('[data-frz-nav]'); if (!nav) return;
    var links = $$('[data-frz-navlabel]').map(function (s) { return { id: s.id, label: s.getAttribute('data-frz-navlabel') }; }).filter(function (x) { return x.id && x.label && x.label !== '-'; });
    $('[data-slot="navlinks"]', nav).innerHTML = links.map(function (l) { return '<a href="#' + esc(l.id) + '">' + esc(l.label) + '</a>'; }).join('');
  }

  /* ---------- AUFTRAG-95: Adresse folgt der Auswahl (assets/auswahl-link.js) ----------
     variant = Variante (Karussell, Lagersystem, Befüllung, MDR), z = angehakte Zubehörteile (Handle~SKU der gewählten Ausführung,
     "-" = alle abgewählt), q = Menge, p = Position im Lagersystem (1-basiert). Ungültiges fällt still auf den Standard zurück. */
  function auswahlUpdate() { if (window.CryonosAuswahl) window.CryonosAuswahl.update(true); }
  function auswahlRestore() {
    var AW = window.CryonosAuswahl; if (!AW) return;
    AW.register(function () {
      var c = cur(), z = [], cfgList = CF.accCfg();
      cfgList.forEach(function (a) {
        var st = S.adds[a.key]; if (!st || !st.on) return;
        var v = a.variants.filter(function (x) { return x.id === st.vid; })[0] || (a.match ? null : a.variants[0]);
        if (!v) { z.push(encodeURIComponent(a.handle) + '~'); return; } /* angehakt, Ausführung noch nicht gewählt */
        var same = a.variants.filter(function (x) { return x.handle === v.handle && v.sku && x.sku === v.sku; }).length; /* SKU nur, wenn eindeutig; sonst #Varianten-ID */
        z.push(AW.itemStr(v.handle || a.handle, a.variants.length > 1 ? (v.sku && same === 1 ? v.sku : ('#' + v.id)) : ''));
      });
      return { variant: String(c.v.id), z: z.length ? z.join(',') : (cfgList.length ? '-' : null), q: qty() > 1 ? String(qty()) : null, p: S.pos > 0 ? String(S.pos + 1) : null };
    });
    var q = AW.readInt('q'), qin = $('[data-frz-qty-input]', HERO);
    if (q && qin) qin.value = q;
    var p = AW.readInt('p'); if (p) S.pos = p - 1;
    var zraw = AW.read('z');
    if (zraw != null) {
      var zl = AW.readList('z');
      CF.accCfg().forEach(function (a) {
        var st = accState(a), hit = null;
        st.on = false;
        if (zl.some(function (x) { return x.h === a.handle && x.s === ''; })) { st.on = true; return; }
        a.variants.forEach(function (v) {
          zl.forEach(function (x) {
            if (x.h !== (v.handle || a.handle)) return;
            if (x.s == null || x.s === v.sku || x.s === '#' + v.id) { if (!hit) hit = v; }
          });
        });
        if (hit) { st.on = true; st.vid = hit.id; }
      });
    }
  }

  function init() {
    HERO = $('[data-frz="hero"]'); if (!HERO) return;
    if (!boot()) return;
    var acc = readJson('frz-acc'); CF.ACC = acc || { items: [] };
    var start = CF.variants.filter(function (v) { return String(v.id) === String(CF.D.current); })[0];
    try { var q = new URL(location.href).searchParams.get('variant'); var qv = CF.variants.filter(function (v) { return String(v.id) === String(q); })[0]; if (qv) start = qv; } catch (e) { /* ohne */ }
    start = start || CF.variants[0];
    S.sel = selFromVariant(start); S.pos = 0; S.slide = 0; S.adds = {}; S.hl = 0; S.view = 'top'; S.hot = 0; S.dims = false;
    auswahlRestore();
    CF.renderers.hero = renderHero; CF.renderers.overview = renderOverview; CF.renderers.anlage = renderAnlage;
    buildNav(); bind(); bindThumbStrip(); renderAll();
    document.dispatchEvent(new CustomEvent('freezer:ready'));
  }
  CF.init = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { CF.ready = false; });
})();
